import { render, staticRenderFns } from "./block-accordions-wrapper.vue?vue&type=template&id=55450c8c&scoped=true&"
import script from "./block-accordions-wrapper.vue?vue&type=script&lang=js&"
export * from "./block-accordions-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./block-accordions-wrapper.vue?vue&type=style&index=0&id=55450c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55450c8c",
  null
  
)

export default component.exports